import type * as THREE from 'three';

const SECTION_BOUNDARY_TOLERANCE_METERS = 1e-7;

/**
 * 剖面视图选取可见性策略。
 *
 * GPU 局部裁剪不会改变 Raycaster 命中结果，因此所有实体拾取必须通过本策略丢弃
 * 已被任一活动剖切面裁掉的命中点；边界公差保留原实体拓扑的可选取能力。
 * 策略只持有活动平面引用，不创建 GPU 资源；控制器释放时调用 `clear()` 断开引用。
 */
export class SectionViewVisibilityPolicy {
    /** 当前活动剖切面引用；由控制器稳定复用，不复制平面对象。 */
    private activePlanes: readonly THREE.Plane[] = [];

    /**
     * 更新活动剖切面。
     *
     * @param planes 当前参与裁剪的平面。
     * @returns 无返回值。
     */
    public setPlanes(planes: readonly THREE.Plane[]): void {
        this.activePlanes = planes;
    }

    /**
     * 清空活动剖切面并恢复完整选取范围。
     *
     * @returns 无返回值。
     */
    public clear(): void {
        this.activePlanes = [];
    }

    /**
     * 判断世界空间点是否位于全部保留半空间内。
     *
     * @param worldPoint Raycaster 命中点。
     * @returns 可见且允许选择时返回 true。
     */
    public isPointVisible(worldPoint: THREE.Vector3): boolean {
        for (const plane of this.activePlanes) {
            if (plane.distanceToPoint(worldPoint) < -SECTION_BOUNDARY_TOLERANCE_METERS) {
                return false;
            }
        }
        return true;
    }
}
